<template>
  <div class="hxStatic">
    <a class="rules" @click="$router.push('/hxrule')">活动细则</a>
    <!-- 广告 -->
    <div class="adv" v-show="cardType === 1">
      <img src="@/assets/hxStatic/title_bglf.png" @click="cardType = 2" />
      <div class="bottom">
        <div>
          <div class="localize">首刷礼</div>
          <img src="@/assets/hxStatic/title_lfm1.png" />
          <div>50元微信立减金</div>
        </div>
        <div>
          <div class="localize">月月礼</div>
          <img src="@/assets/hxStatic/title_lfm2.png" />
          <div>最高180元代金券</div>
        </div>
      </div>
    </div>

    <div class="adv" v-show="cardType === 2">
      <img src="@/assets/hxStatic/title_bgrg.png" @click="cardType = 1" />
      <div class="bottom">
        <div>
          <div class="localize">首刷礼</div>
          <img src="@/assets/hxStatic/title_rgm1.png" />
          <div>30元微信立减金</div>
        </div>
        <div>
          <div class="localize">月月礼</div>
          <img src="@/assets/hxStatic/title_rgm2.png" />
          <div>最高120元代金券</div>
        </div>
      </div>
    </div>
    <!-- 卡片 -->
    <div class="card" v-show="cardType === 1">
      <img src="@/assets/hxStatic/card_title1.png" />
      <div class="futop"></div>
      <div class="list">
        <div class="flex">
          <img src="@/assets/hxStatic/list1.png" />
          <div>
            <h3>华夏信用卡银联人民币白金卡</h3>
            <ul>
              <li>核卡首年免年费</li>
              <li>超长120小时失卡保障</li>
            </ul>
          </div>
        </div>
        <div class="botFlex">
          <div class="lf">为高端人士量身定做</div>
          <div
            class="rg"
            @click="
              jump([
                'wshx/m0.do?showCards=0050&_locale=zh_CN&requestId=2088&subRequestPage=1577700001',
                'wshx/m0.do?showCards=0050&_locale=zh_CN&requestId=2109&subRequestPage=1577100001',
                'wshx/m0.do?showCards=0050&_locale=zh_CN&requestId=2088&subRequestPage=1577600001',
                'wshx/m0.do?showCards=0050&_locale=zh_CN&requestId=2109&subRequestPage=1577200001',
                'wshx/m0.do?showCards=0050&_locale=zh_CN&requestId=2008&subRequestPage=1577500001',
                'wshx/m0.do?showCards=0050&_locale=zh_CN&requestId=2110&subRequestPage=1577300001',
                'wshx/m0.do?showCards=0050&_locale=zh_CN&requestId=2108&subRequestPage=1577800001',
                'wshx/m0.do?showCards=0050&_locale=zh_CN&requestId=2111&subRequestPage=1577400001'
              ])
            "
          >
            立即申请
          </div>
        </div>
      </div>

      

      <div class="list">
        <div class="flex">
          <img src="@/assets/hxStatic/list3.png" />
          <div>
            <h3>华夏精英悦动信用卡</h3>
            <ul>
              <li>机场贵宾厅权益2次/年</li>
              <li>核卡首年免年费</li>
            </ul>
          </div>
        </div>
        <div class="botFlex">
          <div class="lf">健身达人专属权益</div>
          <div
            class="rg"
            @click="
              jump([
                'wshx/m0.do?showCards=0117&v1=1.0&_locale=zh_CN&requestId=2088&subRequestPage=1577700001',
                'wshx/m0.do?showCards=0117&v1=1.0&_locale=zh_CN&requestId=2109&subRequestPage=1577100001',
                'wshx/m0.do?showCards=0117&v1=1.0&_locale=zh_CN&requestId=2088&subRequestPage=1577600001',
                'wshx/m0.do?showCards=0117&v1=1.0&_locale=zh_CN&requestId=2109&subRequestPage=1577200001',
                'wshx/m0.do?showCards=0117&v1=1.0&_locale=zh_CN&requestId=2008&subRequestPage=1577500001',
                'wshx/m0.do?showCards=0117&v1=1.0&_locale=zh_CN&requestId=2110&subRequestPage=1577300001',
                'wshx/m0.do?showCards=0117&v1=1.0&_locale=zh_CN&requestId=2108&subRequestPage=1577800001',
                'wshx/m0.do?showCards=0117&v1=1.0&_locale=zh_CN&requestId=2111&subRequestPage=1577400001'
              ])
            "
          >
            立即申请
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-show="cardType === 2">
      <img src="@/assets/hxStatic/card_title2.png" />
      <div class="futop"></div>
    

      <div class="list">
        <div class="flex">
          <img src="@/assets/hxStatic/list5.png" />
          <div>
            <h3>华夏熊猫旅游卡・金卡</h3>
            <ul>
              <li>核卡首年免年费</li>
              <li>挂失前120小时失卡保障</li>
            </ul>
          </div>
        </div>
        <div class="botFlex">
          <div class="lf">畅游世界，乐享旅途</div>
          <div
            class="rg"
            @click="
              jump([
                'sanfang/pandaCardChoice.html?_locale=zh_CN&v1=1.2&requestId=2088&subRequestPage=1577700001&channelId=sanfang',
                'sanfang/pandaCardChoice.html?_locale=zh_CN&v1=1.2&requestId=2109&subRequestPage=1577100001&channelId=sanfang',
                'sanfang/pandaCardChoice.html?_locale=zh_CN&v1=1.2&requestId=2088&subRequestPage=1577600001&channelId=sanfang',
                'sanfang/pandaCardChoice.html?_locale=zh_CN&v1=1.2&requestId=2109&subRequestPage=1577200001&channelId=sanfang',
                'sanfang/pandaCardChoice.html?_locale=zh_CN&v1=1.2&requestId=2008&subRequestPage=1577500001&channelId=sanfang',
                'sanfang/pandaCardChoice.html?_locale=zh_CN&v1=1.2&requestId=2110&subRequestPage=1577300001&channelId=sanfang',
                'sanfang/pandaCardChoice.html?_locale=zh_CN&v1=1.2&requestId=2108&subRequestPage=1577800001&channelId=sanfang',
                'sanfang/pandaCardChoice.html?_locale=zh_CN&v1=1.2&requestId=2111&subRequestPage=1577400001&channelId=sanfang'
              ])
            "
          >
            立即申请
          </div>
        </div>
      </div>
    </div>

    <a
      class="more"
      @click="$router.push('/hxrule')"
    >
      查看更多卡种
    </a>
    <!-- 活动 -->
    <div class="activity" v-show="cardType === 1">
      <img src="@/assets/hxStatic/activity_title.png" />
      <div class="futop"></div>
      <div class="title">畅享首刷礼</div>
      <div class="txt">
        新户自核卡起60天内（含），线上消费满2笔且单笔满199元，可享50元微信立减金礼包。
      </div>
      <div class="title">畅享月月礼</div>
      <div class="txt">
        新户自核卡次月起6个月内，每月消费交易满2笔且每笔满199元，即可每月领取价值30元代金券。每人每月限领1次。
      </div>
      <div class="lists">
        <div>
          <img src="@/assets/hxStatic/list_wx.jpg" />
          <h4>微信30元立减金</h4>
        </div>
        <div>
          <img src="@/assets/hxStatic/list_bsk.jpg" />
          <h4>必胜客30元代金券</h4>
        </div>
        <div>
          <img src="@/assets/hxStatic/list_tm.jpg" />
          <h4>天猫30元购物券</h4>
        </div>
        <div>
          <img src="@/assets/hxStatic/list_jd_30.jpg" />
          <h4>京东E卡30元面值</h4>
        </div>
      </div>
    </div>

    <div class="activity" v-show="cardType === 2">
      <img src="@/assets/hxStatic/activity_title.png" />
      <div class="futop"></div>
      <div class="title">怡享首刷礼</div>
      <div class="txt">
        新户自核卡起60天内（含），线上消费满2笔且单笔满99元，可享30元微信立减金礼包。
      </div>
      <div class="title">怡享月月礼</div>
      <div class="txt">
        新户自核卡次月起6个月内，每月消费交易满2笔且每笔满99元，即可每月领取价值20元代金券。每人每月限领1次。
      </div>
      <div class="lists">
        <div>
          <img src="@/assets/hxStatic/list_wx.jpg" />
          <h4>微信20元立减金</h4>
        </div>
        <div>
          <img src="@/assets/hxStatic/list_kdj.jpg" />
          <h4>肯德基20元代金券</h4>
        </div>
        <div>
          <img src="@/assets/hxStatic/list_tm.jpg" />
          <h4>天猫20元购物券</h4>
        </div>
        <div>
          <img src="@/assets/hxStatic/list_jd_20.jpg" />
          <h4>京东E卡20元面值</h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
export default {
  data() {
    return {
      cardType: 1
    }
  },
  mounted() {},
  methods: {
    // RouterType: 0：华夏银行信用卡公众号, 1：华夏银行公众号, 2：华夏银行信用卡小程序, 3：华夏银行小程序, 4：华彩生活App, 5：手机银行App, 6:华夏银行信用卡官网, 7:华夏银行官网
    jump(val) {
      if (!val) return
      const jumpBaseUrl = 'https://creditapply.hxb.com.cn/'
      const type = Number(this.$route.query?.type)
      if (![0, 1, 2, 3, 4, 5, 6, 7].includes(type)) {
        Toast.fail('请携带正确参数!')
        return
      }

      window.location.replace(jumpBaseUrl + val[type])
    }
  }
}
</script>

<style lang="less" scoped>
.hxStatic {
  min-height: 100vh;
  position: relative;
  background: url('~@/assets/hxStatic/bg.jpg') #fce2d1 no-repeat;
  background-size: contain;
  padding-bottom: 40px;
  box-sizing: border-box;
  position: relative;
  .rules {
    position: absolute;
    right: 0;
    top: 34px;
    width: 12px;
    padding: 6px 12px 6px 6px;
    font-size: 13px;
    color: #795248;
    background: linear-gradient(to right, #feedd1, #f9d5a4);
    border: solid 1px #fffcf7;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
  }
  .adv {
    padding: 336px 16px 16px;
    & > img {
      width: 100%;
      display: block;
    }
    .bottom {
      margin-top: -50px;
      padding: 16px;
      background: #fff;
      display: flex;
      border-radius: 30px 30px 16px 16px;
      width: 100%;
      box-sizing: border-box;
      justify-content: space-between;
      & > div {
        width: 150px;
        font-size: 14px;
        color: #333333;
        text-align: center;
        position: relative;
        img {
          width: 100%;
          display: block;
          margin-bottom: 12px;
        }
        .localize {
          position: absolute;
          top: 5px;
          left: 50%;
          transform: translateX(-50%);
          font-size: 12px;
          color: #a45541;
        }
      }
    }
  }
  .card {
    background: #fff;
    border-radius: 8px 30px 16px 16px;
    margin: 0 16px;
    & > img {
      width: 100%;
      display: block;
    }
    .futop {
      margin-top: -30px;
    }
    .list {
      margin: 0px 12px 16px;
      padding-bottom: 16px;
      border-bottom: 1px solid #eeeeee;
      :first-child {
        padding-top: -25px;
      }
      .flex {
        display: flex;
        // justify-content: space-between;
        align-items: center;
        font-size: 14px;
        img {
          width: 130px;
          height: 82px;
          margin-right: 8px;
        }
        ul {
          font-size: 12px;
          color: #666666;
          padding: 12px 0 0 15px;
          list-style: disc;
          line-height: 1.5;
        }
      }
      .botFlex {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 13px;
        .lf {
          width: 184px;
          height: 24px;
          line-height: 24px;
          background: linear-gradient(to right, #ffeedf, #fffdfb);
          font-size: 12px;
          color: #a56426;
          border-radius: 15px;
          padding-left: 8px;
          box-sizing: border-box;
        }
        .rg {
          width: 92px;
          line-height: 32px;
          background: linear-gradient(0deg, #f6b583, #d88656);
          font-size: 14px;
          color: #ffffff;
          text-align: center;
          border-radius: 15px;
        }
      }
    }
  }
  .more {
    width: 90px;
    line-height: 26px;
    background-image: linear-gradient(
      90deg,
      rgba(255, 150, 64, 0.16) 2%,
      rgba(255, 194, 104, 0.14) 100%
    );
    border-radius: 12px;
    font-size: 12px;
    color: #a56426;
    margin: 12px auto 16px;
    display: block;
    text-align: center;
  }

  .activity {
    border-radius: 8px 30px 16px 16px;
    margin: 0 16px 0px;
    background: #fff;
    & > img {
      width: 100%;
      display: block;
    }
    .futop {
      margin-top: -50px;
    }
    .title {
      width: 90px;
      line-height: 21px;
      padding: 0 0px 0 16px;
      font-size: 12px;
      color: #fff;
      background: linear-gradient(to right, #f8816a, #ffc6ab);
      border-top-right-radius: 15px;
      border-bottom-right-radius: 15px;
      // background: url('~@/assets/hxStatic/activitytitle_bg.png');
      box-sizing: border-box;
      position: relative;
    }
    .txt {
      font-size: 12px;
      color: #333333;
      line-height: 24px;
      font-weight: 400;
      padding: 0 16px 14px;
    }
    .lists {
      display: flex;
      flex-flow: wrap;
      font-size: 13px;
      color: #333333;
      justify-content: space-around;
      padding-bottom: 10px;
      text-align: center;
      & > div {
        margin-bottom: 12px;
        & > img {
          width: 117px;
          height: 72px;
          margin-bottom: 4px;
        }
      }
    }
  }
}
</style>
